import solarLunar from 'solarlunar'

pageId = "page-calendar"
calendarData = {}


$ ->
  $(document)
    # show/hide calendar setting popover
    .on 'click', "##{pageId} .cal-list .link-cal-setting", calendarSettingClick

    # change calendar color
    .on 'click', ".cal-setting-popover .link-cal-color", calendarColorClick

    # show/hide calendar sidebar
    .on 'click', "##{pageId} .btn-toggle-sidebar", toggleSidebar

    # filter events and todos
    .on 'click', "##{pageId} .cal-list .link-show-cal", toggleCalendarClick
    .on 'click', "##{pageId} .cal-list .cal-name", toggleOneCalendarClick

    # show/hide todos
    .on 'click', "##{pageId} .cals-control .show-todos", (e) ->
      toggleTodos !$(@).hasClass('on')

    # show/hide avatars
    .on 'click', "##{pageId} .cals-control .show-avatars", (e) ->
      toggleAvatars !$(@).hasClass('on')

    # show/hide current member events
    .on 'click', "##{pageId} .cals-control .show-my-events", (e) ->
      toggleMyEvents !$(@).hasClass('on')

    # event popover
    .on 'click', ".cal-event-popover .btn-save-event", saveEventClick
    .on 'click', ".cal-event-popover .link-hide-popover", cancelEventClick
    .on 'click', ".cal-event-popover .link-toggle-options", toggleMoreClick
    .on 'change', ".cal-event-popover #select-schedule-every", scheduleEveryChange
    .on 'click', ".cal-event-popover .link-add-more", ->
      $form = $(@).closest('.form-event')
      window.calEventData = $form.serializeArray()
      calEventData.push
        name: 'cb-all-day'
        value: $form.find('.cb-all-day').is(':checked')

    .on 'click', '.link-create-calendar', ->
      tower.bubbleGuideExpire step: 8

  tower.stack.on 'pageunload', (e, $page, pageParams) ->
    if $page.is("##{pageId}")
      $('body').removeClass('body-calendar')

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('body').addClass('body-calendar')
  $('#nav-calendar').addClass('active')
  url = simple.url()
  month = url.getParam('month')
  date = moment(month, 'YYYY-MM', true)
  date = if date.isValid() then date else tower.now()

  $page.find('.calendar-title').text date.format('YYYY 年 M 月')

  prevDate = date.clone().subtract(1, 'month')
  nextDate = date.clone().add(1, 'month')

  $page.find(".btn-prev-month").attr 'href', "#{url.pathname}?month=#{prevDate.format('YYYY-MM')}"
  $page.find(".btn-next-month").attr 'href', "#{url.pathname}?month=#{nextDate.format('YYYY-MM')}"
  $page.find(".btn-today").attr 'href', "#{url.pathname}?month=#{moment().format('YYYY-MM')}"

  calendar = simple.calendar
    el: '#calendar'
    month: date.format('YYYY-MM')
    timezone: tower.me.tz
    eventKeys:
      id: 'guid'
      start: 'starts_at'
      end: 'ends_at'
      content: 'content'
    todoKeys:
      id: 'guid'
      start: 'start_at'
      end: 'due_at'
      completed: 'completed'
      content: 'content'
    onDayRender: renderLunarDateOnDay

  calendar.on 'eventrender', (e, event, $event) ->
    $content = $event.find('.content')
    allDay = @isAllDayEvent(event)

    if event.origin.is_todo
      $event.addClass "cal-color-#{event.origin.project_color}"
      $event.attr('data-assignee-guid', event.origin.assignee_guid)
      $event.attr('data-label-ids', event.origin.label_ids) if event.origin.label_ids
    else
      $event.addClass "cal-color-#{event.origin.calendar_color}"

    if !allDay and !event.origin.create and !event.origin.is_todo
      $time = $('<span class="time"></span>')
      $time.text("#{event.start.format('HH:mm')} - #{event.end.format('HH:mm')}")
        .prependTo($content)

    if event.origin.is_todo
      renderTodoMember(event, $content)
    else
      renderEventMembers(event, $content, allDay)

    if event.origin.loading
      $event.addClass 'loading'

    if event.origin.caleventable_type == 'Project'
      $event.attr 'data-project-guid', event.origin.caleventable_guid

    $content.wrapInner '<span class="text"></span>'

  calendar.on 'todorender', (e, todo, $todo) ->
    $todo.addClass "cal-color-#{todo.origin.project_color}"
    $todo.attr('data-assignee-guid', todo.origin.assignee_guid)
    if todo.origin.label_ids
      $todo.attr('data-label-ids', todo.origin.label_ids)

    renderTodoMember(todo, $todo.find('.content'))

  calendar.on 'dayclick', calendarDayClick

  calendar.on 'eventclick', eventClick

  calendar.on 'todoclick', todoClick

  calendar.on 'todocomplete', todoComplete

  calendar.on 'eventdrop', (e, event, differ) ->
    ajaxOption =
      url: "/teams/#{tower.team.guid}/calendar_events/#{event.id}/update_date"
      dataType: 'json'
      type: 'post'
      data:
        starts_at: event.start.format('YYYY-MM-DD HH:mm:ss')
        ends_at: event.end.format('YYYY-MM-DD HH:mm:ss')
      success: (result) ->
        month = calendar.month.format('YYYY-MM')
        events = calendarData[month].events
        for item in result.calendar_events
          events.forEach (ele, index) ->
            if item.guid is ele.guid
              events.splice index, 1, item
              return
          if events.indexOf(item) is -1 and moment(item.starts_at).format('YYYY-MM') is month
            events.push item

        renderEventsAndTodos()
      error: ->
        event.start.add('d', differ)
        event.end.add('d', differ)
        calendar.replaceEvent(event)

    if event.origin.repeat_starts_at
      confirmContent = $(simple.tpl($('#tpl-period-update-popover').html()))
      $pointTo = $page.find("[data-id=#{event.origin.guid}] .content .text")
      popover = simple.popover
        pointTo: $pointTo
        content: confirmContent
        autohide: false

      $(document).find('.period-update-popover .btn').one 'click', (e) ->
        e.preventDefault()
        popover.destroy()
        $btn = $(e.currentTarget)
        if $btn.is '.btn-yes'
          ajaxOption.data['repeat_modify'] = 1
          $.ajax ajaxOption
        else if $btn.is '.btn-no'
          $.ajax ajaxOption
        else if $btn.is '.btn-nevermind'
          ajaxOption.error()
    else
      $.ajax ajaxOption

  filterKeys = simple.util.storage.get getLocalStorageKey()
  if filterKeys
    filterKeys = filterKeys.split ','
    $page.find(".cal-list li").each (i, li) ->
      $li = $(li)
      $li.find('.link-show-cal').toggleClass('selected', $.inArray($li.data('guid'), filterKeys) > -1)

  fetchData()

  if simple.util.storage.get('calendarExpanded')
    toggleSidebar()

  if simple.util.storage.get('calendarShowTodos') == 'false'
    toggleTodos false

  if simple.util.storage.get('calendarShowAvatars') == 'false'
    toggleAvatars false

  tower.showBubbleGuide steps: [8]
  toggleCals()


fetchRequest = null
fetchData = ->
  calendar = $('#calendar').data('calendar')
  return unless calendar
  month = calendar.month.format('YYYY-MM')

  if calendarData[month]
    renderEventsAndTodos()
    refreshProjectList()

  if fetchRequest
    fetchRequest.abort()
    fetchRequest = null

  $("##{pageId} .cal-loading").show()
  fetchRequest = $.ajax
    type: "get"
    url: calendar.el.data('url')
    data:
      start: calendar.el.find('.day:first').data('date')
      end: calendar.el.find('.day:last').data('date')
  .done (result) ->
    calendarData[month] =
      events: result.calendar_events
      todos: result.todos
    renderEventsAndTodos()
    refreshProjectList()
    $("##{pageId} .cal-loading").hide()

renderEventsAndTodos = () ->
  calendar = $('#calendar').data('calendar')
  return unless calendar
  data = calendarData[calendar.month.format 'YYYY-MM']
  return unless data

  onlyShowMyEvents = $("##{pageId} .cals-control .show-my-events").hasClass('on')

  selected = []
  filtered =
    events: []
    todos: []
  $("##{pageId} .cal-list .link-show-cal.selected").each (i, link) ->
    $li = $(link).closest('li')
    selected.push $li.data('guid')

  $.each data.events, (i, event) ->
    if ($.inArray(event.caleventable_guid, selected) > -1) && (!onlyShowMyEvents || event.my_own)
      filtered.events.push(event)

  $.each data.todos, (i, todo) ->
    if ($.inArray(todo.project_guid, selected) > -1) && (!onlyShowMyEvents || todo.my_own)
      filtered.todos.push(todo)

  calendar.clearEvents()
  calendar.clearTodos()
  calendar.addEvent filtered.events
  calendar.addTodo filtered.todos

  simple.util.storage.set getLocalStorageKey(), selected.join(',')

renderLunarDateOnDay = (date, el) ->
  year = date.year()
  month = date.month() + 1
  day = date.date()
  cnDay = solarLunar.solar2lunar(year, month, day)['dayCn']

  $(el).find('.info').append("<span class='cn-day'>#{cnDay}</span>")

refreshProjectList = ->
  $calendar = $('#calendar')
  calendar = $calendar.data 'calendar'
  return unless calendar
  data = calendarData[calendar.month.format 'YYYY-MM']
  return unless data
  projects = []

  for item in $.merge($.merge([], data.events), data.todos)
    guid = item.caleventable_guid || item.project_guid
    projects.push(guid) if $.inArray(guid, projects) < 0

  $wrapper = $('.project-cals').hide()
  $projects = $wrapper.find('.cal-list li').hide()
  if projects.length > 0
    for guid in projects
      $project = $projects.filter("[data-guid=#{guid}]").show()
      $wrapper.show()  if $project.length

toggleCalendarClick = (e) ->
  e.preventDefault()
  $li = $(@).closest 'li'
  $li.find('.link-show-cal').toggleClass 'selected'
  renderEventsAndTodos()

toggleOneCalendarClick = (e) ->
  $cb = $(@).siblings('.link-show-cal')
  $list = $("##{pageId} .cal-list")

  if $cb.hasClass('selected') and $list.find( "li .link-show-cal.selected" ).length == 1
    $list.find('li .link-show-cal' ).addClass('selected')
  else
    $list.find('.link-show-cal').removeClass('selected')
    $cb.addClass('selected')

  renderEventsAndTodos()

toggleTodos = (show) ->
  $link = $('.cals-control .show-todos')

  $('#calendar').toggleClass('calendar-hide-todos', !show)
  simple.util.storage.set('calendarShowTodos', show)

  if show
    $link.addClass('on')
      .find('.twr')
      .removeClass('twr-ban')
      .addClass('twr-check-circle')
  else
    $link.removeClass('on')
      .find('.twr')
      .removeClass('twr-check-circle')
      .addClass('twr-ban')

toggleMyEvents = (show) ->
  $link = $('.cals-control .show-my-events')

  if show
    $link.addClass('on')
      .find('.twr')
      .removeClass('twr-ban')
      .addClass('twr-check-circle')
  else
    $link.removeClass('on')
      .find('.twr')
      .removeClass('twr-check-circle')
      .addClass('twr-ban')

  renderEventsAndTodos()

toggleAvatars = (show) ->
  $link = $('.cals-control .show-avatars')

  $('#calendar').toggleClass('calendar-hide-avatars', !show)
  simple.util.storage.set('calendarShowAvatars', show)

  if show
    $link.addClass('on')
      .find('.twr')
      .removeClass('twr-ban')
      .addClass('twr-check-circle')
  else
    $link.removeClass('on')
      .find('.twr')
      .removeClass('twr-check-circle')
      .addClass('twr-ban')

toggleSidebar = ->
  $btn = $("##{pageId} .btn-toggle-sidebar")
  $wrapper = $btn.closest('.calendar-wrapper')

  if $wrapper.hasClass('expand')
    $wrapper.removeClass('expand')
    $btn.removeClass('sidebar-collapsed')
      .attr('title', '隐藏侧边栏')
    simple.util.storage.remove('calendarExpanded')
  else
    tower.bubbleGuideExpire step: 8

    $wrapper.addClass('expand')
    $btn.addClass('sidebar-collapsed')
      .attr('title', '显示侧边栏')
    simple.util.storage.set('calendarExpanded', true)

calendarSettingClick = (e) ->
  e.preventDefault()
  $link = $(@)
  $calItem = $link.closest('li')
  color = $calItem.data('color')
  calGuid = $calItem.data('guid')
  creatorGuid = $calItem.data('creator')

  if !tower.me.admin and tower.me.guid != creatorGuid
    return

  popover = simple.popover
    pointTo: $link
    content: $(simple.tpl($("#tpl-cal-settings").html()))
    position: "bottom-left"

  popover.on 'popover:beforeAutohide', (e) ->
    return false if $('.simple-dialog').length > 0

  popoverEl = popover.el

  if $calItem.is('[data-project]')
    popoverEl.find('.cal-setting-field').remove()
  else
    popoverEl.find('.link-edit-cal').attr('href', "/calendars/#{calGuid}/settings/")

    if $calItem.is('[data-system="true"]')
      popoverEl.find('.link-delete-calendar').remove()
    else
      popoverEl.find('.link-delete-calendar')
        .attr('href', "/calendars/#{calGuid}/delete/" )
        .one 'ajax:success', (e) ->
          popover.destroy()
          $calItem.fadeOut 200, ->
            $(@).remove()
            renderEventsAndTodos()

  popoverEl.find(".link-cal-color.cal-color-#{color}")
    .addClass('selected')
    .siblings('.link-cal-color')
    .removeClass('selected')

calendarColorClick = (e) ->
  $link = $(@)
  oldColor = $link.siblings('.link-cal-color.selected').data('color')
  color = $link.data('color')
  $popover = $link.closest('.simple-popover')
  popover = $popover.data('popover')
  $li = popover.pointTo.closest('li')
  isProject = $li.is('[data-project]')
  url = $li.find('.link-cal-setting').data('url')
  guid = $li.data 'guid'

  $link.addClass('selected')
    .siblings('.link-cal-color')
    .removeClass( "selected" )

  $.ajax
    url: url
    type: 'post'
    data:
      'calendar_color': color

  $li.attr('data-color', color)
    .data('color', color)
    .find('.link-cal-color')
    .removeClass('cal-color-' + oldColor)
    .addClass('cal-color-' + color)

  calendar = $('#calendar').data('calendar')
  return unless calendar
  data = calendarData[calendar.month.format 'YYYY-MM']

  for event in data.events
    event.calendar_color = color if event.caleventable_guid == guid

  if isProject
    for todo in data.todos
      todo.project_color = color if todo.project_guid == guid

  renderEventsAndTodos()
  popover.destroy()

$startMoment = null
$endMoment = null
$untilMoment = null
calendarDayClick = (e, $day) ->
  calendar = @
  $popTarget = calendar.el.find( ".popover-pointTo" )
  if $popTarget.length > 0
    $popTarget.data("popover").destroy()
    return

  start = tower.moment $day.data('date')
  end = start.clone().endOf('day')
  currentCal = $('.cal-list .link-show-cal.selected:first').closest('li').data('guid')
  $popover = $(simple.tpl($("#tpl-event-popover").html()))
  $select = generateCalendarSelect($popover, currentCal)

  calendar.removeEvent 'PLACEHOLDER'
  calendar.addEvent
    content: "新的日程安排"
    guid: "PLACEHOLDER"
    creator: {}
    starts_at: end.format()
    ends_at: end.format()
    schedule_every: 0
    caleventable_guid: $select.val()
    calendar_color: $select.find("option:selected").data("color")
    create: true

  $event = calendar.el.find(".event[data-id=PLACEHOLDER]")
  popover = simple.popover
    pointTo: $event.find(".content .text")
    cls: 'calendar-event-popover'
    autohide: false
    content: $popover

  popover.on "popover:destroy", (e) ->
    calendar.removeEvent('PLACEHOLDER')

  $popover.data( "event", $event )

  notAllDayChecked = simple.util.storage.get('calendar-not-all-day-checked') == 'true'

  $popover.find('.cb-all-day').on 'click', (e) ->
    $cb = $(@)
    checked = $cb.prop('checked')
    $startMoment.destroy() if $startMoment?
    $endMoment.destroy() if $endMoment?
    $start_input = $popover.find('#start_moment')
    $end_input = $popover.find('#end_moment')
    start_time = start.clone()
    end_time = end.clone()

    simple.util.storage.set('calendar-not-all-day-checked', !checked)

    if checked
      $start_input.addClass('all-day').removeClass('point-in-time')
      $end_input.addClass('all-day').removeClass('point-in-time')
      start_time.hours(0)
      end_time.minute(0)
      end_time.seconds(0)
      end_time.hours(23)
      end_time.minute(59)
      end_time.seconds(59)
    else
      $start_input.addClass('point-in-time').removeClass('all-day')
      $end_input.addClass('point-in-time').removeClass('all-day')
      start_time.hours(9)
      end_time.hours(10)
      end_time.minute(0)
      end_time.seconds(0)

    $startMoment = simple.momentpicker
      el: $start_input
      valueFormat: 'YYYY-MM-DD HH:mm:ss'
      cls: 'calendar-momentpicker'

    $endMoment = simple.momentpicker
      el: $end_input
      valueFormat: 'YYYY-MM-DD HH:mm:ss'
      cls: 'calendar-momentpicker'

    $startMoment.setMoment(start_time)
    $endMoment.setMoment(end_time)

    handleTime = (type) ->
      startTime = $startMoment.getMoment()
      startTimeStamp = startTime.toDate().getTime()
      endTimeStamp = $endMoment.getMoment().toDate().getTime()
      # 是否为全天日程
      allDay = $('.cb-all-day').is(':checked')
      if startTimeStamp >= endTimeStamp
        if type == 'start'
          if allDay
            # 86399秒 == 23小时59分59秒
            $endMoment.setMoment $startMoment.getMoment().add(86399, 'seconds')
          else
            $endMoment.setMoment $startMoment.getMoment().add(1, 'hours')
        else
          if allDay
            $startMoment.setMoment $endMoment.getMoment().add(-86399, 'seconds')
          else
            $startMoment.setMoment $endMoment.getMoment().add(-1, 'hours')
      return

    $startMoment.on 'select', (e, params)->
      handleTime 'start'
      return

    $endMoment.on 'select', (e, params)->
      handleTime 'end'
      return
  .trigger('click')

  $popover.find('.cb-all-day').trigger('click') if notAllDayChecked

  $untilMoment.destroy() if $untilMoment?
  $untilMoment = simple.momentpicker
    el: $('#until_moment')
    cls: 'until-momentpicker calendar-momentpicker'
    displayFormat: 'YYYY/MM/DD'

  $popover.find("#txt-event-content")
    .on 'keydown', (e) ->
      if e.which == 13
        e.preventDefault()
        $popover.find(".btn-save-event").trigger('click')
      else if e.which == 27
        $popover.find(".link-hide-popover").trigger('click')
    .autosize
      callback: () ->
        popover.refresh()
    .focus()

  $popover.find('#txt-event-desc')
    .autosize
      callback: () ->
        popover.refresh()


  $popover.find( "#select-cal" ).trigger('change')
  popover.refresh()
  $popover.find('#txt-event-content')[0].select()


generateCalendarSelect = ($popover, guid) ->
  $selectCal = $popover.find( "#select-cal" ).empty()
  $calendars = $('.standard-cals .cal-list li')
  $projects = $('.project-cals .cal-list li')

  if $calendars.length > 0
    $("<option disabled>---日历---</option>").appendTo($selectCal)

    $calendars.each (i, cal) ->
      $cal = $(cal)
      $("<option/>",
        value: $cal.data('guid')
        text: $cal.find('.cal-name').text()
        "data-color": $cal.data('color')
        'data-members': $cal.data('members')
      ).appendTo($selectCal)

  if $projects.length > 0
    $("<option disabled>---项目---</option>").appendTo($selectCal)

    $projects.each (i, projectEl) ->
      $project = $(projectEl)
      $("<option/>",
        value: $project.data('guid')
        text: $project.find('.cal-name').text()
        "data-color": $project.data('color')
        "data-project": "true"
        'data-members': $project.data('members')
      ).appendTo($selectCal)

  $selectCal.val(guid) if guid

  $selectCal.on "change", (e) ->
    $opt = $(@).find("option:selected")
    $input = $popover.find("[name=caleventable_type]")
    memberGuids = $opt.data('members')?.split(',') || []

    if $opt.is("[data-project]")
      $input.val("Project")
    else
      $input.val("Calendar")

    tower.updateManageMembers($popover.find(".manage-members"), memberGuids)

  $selectCal

toggleMoreClick = (e) ->
  $link = $(@)
  $moreOptions = $link.closest('.more-options')

  if $moreOptions.hasClass('active')
    $moreOptions.removeClass('active')
    $link.find('.twr')
      .removeClass('twr-caret-down')
      .addClass('twr-caret-right')
  else
    $moreOptions.addClass('active')
    $link.find('.twr')
      .removeClass('twr-caret-right')
      .addClass('twr-caret-down')

  $popover = $link.closest('.simple-popover')
  popover = $popover.data('popover')
  popover.refresh()

cancelEventClick = (e) ->
  e.preventDefault()
  $btn = $(@)
  $popover = $btn.closest('.simple-popover')
  popover = $popover.data('popover')
  popover.destroy()

scheduleEveryChange = (e) ->
  select = $(@)
  every = select.val() * 1
  form = select.closest('form')
  untilWrap = form.find('.event-schedule-until')
  untilDate = $endMoment.getMoment()
  intervalWrap = form.find('.event-schedule-interval')
  weekdaysWrap = form.find('.event-schedule-weekdays')

  if every == 0
    untilWrap.removeClass('repeatable').addClass('hide')
    intervalWrap.addClass('hide')
    weekdaysWrap.addClass('hide')
    select.css('width', 193)
  else
    untilWrap.addClass('repeatable').removeClass('hide')
    select.css('width', 77)

    if every == 1
      untilDate.add(6, 'year')
    else if every == 2
      untilDate.add(3, 'month')
    else if every == 3
      untilDate.add(6, 'month')
    else if every == 4
      untilDate.add(1, 'month')
    else if every == 5
      untilDate.add(6, 'month')
      intervalWrap.removeClass('hide')
      weekdaysWrap.removeClass('hide')

  $untilMoment.setMoment(untilDate.format("YYYY-MM-DD"));
  popover = form.closest('.simple-popover').data('popover')
  popover.refresh()

saveEventClick = (e) ->
  e.preventDefault()
  btn = $(@)
  form = btn.closest('.form')
  cal = $('#calendar').data( "calendar" )
  popoverEl = form.closest( ".cal-event-popover" )
  popover = popoverEl.closest('.simple-popover').data('popover')
  txtContent = form.find( "#txt-event-content" )
  content = $.trim(txtContent.val())
  description = $.trim(form.find("#txt-event-desc").val())

  if !content
    errorEl = txtContent.nextAll( ".error" )
    error = txtContent.data("validate-msg")

    if !errorEl.length
      errorEl = $( "<p class='error'></p>" ).appendTo(txtContent.parent())

    txtContent.addClass("error")
    errorEl.text( error ).show()
    popover.refresh()

    return
  else
    txtContent.removeClass("error")

  eventEl = popoverEl.data( "event" )
  popover = eventEl.find(".content .text").data("popover")
  start = $startMoment.getValue()
  end = $endMoment.getValue()
  scheduleEvery = form.find('select[name=schedule_every]').val()*1
  scheduleUntil = form.find('input[name=schedule_until]').val()
  url = form.attr( "action" )
  calendarType = form.find( "input[name=caleventable_type]" ).val()
  selectedCal = form.find( "#select-cal option:selected" )
  calendarGuid = selectedCal.val()
  calendarColor = selectedCal.data( "color" )
  eventId = eventEl.data('id')
  scheduleInterval = form.find('select[name=schedule_interval]').val()
  scheduleWeekdays = []
  $('.checkbox-group input:checked').each ->
    scheduleWeekdays.push $(@).val()

  memberGuids = form.find( ".member.selected" ).map( ->
   $(@).data('guid')
  ).get().join(',')

  popover?.destroy()

  cal.addEvent
    content: "新的日程安排"
    guid: eventId
    creator: tower.me
    starts_at: start
    ends_at: end
    schedule_every: scheduleEvery
    schedule_until: scheduleUntil
    caleventable_guid: calendarGuid
    calendar_color: calendarColor
    caleventable_name: ""
    schedule_interval: scheduleInterval
    scheduleWeekdays: scheduleWeekdays
    create: true
    loading: true

  data =
    content: content
    description: description
    starts_at: start
    ends_at: end
    schedule_until: scheduleUntil
    schedule_every: scheduleEvery
    location: form.find( "input[name=location]" ).val()
    remind_interval: form.find('#select-remind').val()
    is_show_creator: if form.find('input[name=is_show_creator]').is(':checked') then true else undefined
    member_guids: memberGuids
    caleventable_type: calendarType
    caleventable_guid: calendarGuid
    start: cal.month.clone().startOf( "isoweek" ).format( "YYYY-MM-DD" )
    end: cal.month.clone().endOf( "month" ).endOf( "isoweek" ).format( "YYYY-MM-DD" )
    schedule_interval: scheduleInterval
    schedule_weekdays: scheduleWeekdays
  $.ajax
    url: url
    data: data
  .always (result, status) ->
    if status == "success"
      calData = calendarData[cal.month.format 'YYYY-MM']
      if calData
        for event in result.calendar_events
          startTime = tower.moment(event.starts_at)
          endTime = tower.moment(event.ends_at)
          if cal.dateInMonth(startTime) or cal.dateInMonth(endTime)
            calData.events.push event

      $(".cal-list li[data-guid=#{result.calendar_events[0].caleventable_guid}] .link-show-cal")
        .addClass('selected')

      renderEventsAndTodos()
      refreshProjectList()
    else
      cal.removeEvent eventId


deleteCalendarEvent = (event, params)->
  params = params || {}
  loading = simple.loading
      type: 'global',
      msg: '正在删除日程...'
  $.post("/teams/#{tower.team.guid}/calendar_events/#{event.id}/delete", params)
    .done (e)->
      tower.stack.load window.location.href,
        root: true
        fluid: true
      loading.destroy();


eventClick = (e, event, $event) ->
  return if event.id == 'PLACEHOLDER'
  calendar = $('#calendar').data('calendar')

  $popover = $($('#tpl-event-click-popover').html())
    .attr('data-creator-guid', event.origin.creator.guid)

  if event.origin.is_show_creator
    $popover.find('.cal-event-item-avatar')
      .replaceWith("""<img class="avatar cal-event-item-avatar cal-event-item-icon" src="#{event.origin.creator.avatar}">""")

  $popover.find('.cal-event-parent').text event.origin.caleventable_name

  if calendar.isAllDayEvent(event)
    if event.start.isSame(event.end, 'day')
      time = event.start.format('M月D日')
    else
      time = "#{event.start.format('M月D日')} - #{event.end.format('M月D日')}"
  else
    if event.start.isSame(event.end, 'day')
      time = "#{event.start.format('M月D日 HH:mm')} - #{event.end.format('HH:mm')}"
    else
      time = "#{event.start.format('M月D日 HH:mm')} - #{event.end.format('M月D日 HH:mm')}"
  $popover.find('.time').text(time)

  $popover.find('.content').text(event.content)
    .attr('href', "/teams/#{tower.team.guid}/calendar_events/#{event.id}")

  $popover.find('.desc').text(event.origin.description)

  $popover.find('.edit-link')
    .attr('href', "/teams/#{tower.team.guid}/calendar_events/#{event.id}/edit")

  $popover.find('.more-info')
    .attr('href', "/teams/#{tower.team.guid}/calendar_events/#{event.id}")

  if event.origin.participants.length
    $container = $popover.find('.participants')
    tpl = """
      <a href="" class="participant" data-stack data-stack-root data-parent-name="日历" data-parent-url="#{simple.url().pathname}?month=#{calendar.month.format('YYYY-MM')}" data-parent-fluid>
        <img src="" alt="" class="avatar">
      </a>
    """
    for participant in event.origin.participants
      $tpl = $(tpl).attr('href', "/members/#{participant.guid}").data('guid', participant.guid)
      $tpl.find('.avatar').attr('src', participant.avatar)
        .attr('alt', participant.nickname)
        .data('guid', participant.guid)
      $tpl.appendTo $container
  else
    $popover.find('.cal-event-item-participants').remove()

  if !event.origin.description
    $popover.find('.cal-event-item-description').remove()

  $pointTo = $event.find('.content .text')
  if $pointTo.outerWidth() > $pointTo.parent().width()
    $pointTo = $pointTo.parent()

  popover = simple.popover
    pointTo: $pointTo
    content: $popover
    cls: 'calendar-event-popover'

  popover.on 'popover:beforeAutohide', (e) ->
    return false if $('.simple-dialog').length > 0

  $popover.on 'click', ".delete-link", (e)->
    if event.origin.schedule_id == 0
      dialog = simple.dialog.confirm
        content: "确定删除这条日程吗？"
        buttons: [{
          text: "确定",
          callback: ->
            deleteCalendarEvent(event)
        }, {
          text: "取消",
          cls: "btn-x",
          callback: (e)->
            dialog.remove()
        }]
    else
      dialog = simple.dialog
        content: "这是一个重复事件，你想？"
        cls: 'page-calendar-remove-dialog period-destroy-confirm'
        width: 300
        buttons: [{
          text: "删除当前和后续所有重复事件"
          cls: 'btn-mini btn-no'
          callback: (e)->
            deleteCalendarEvent(event, {repeat_modify: 1})
        }, {
          text: "只删除当前事件"
          cls: 'btn-mini btn-no'
          callback: (e)->
            deleteCalendarEvent(event, {repeat_modify: 0})
        }, {
          text: "取消删除"
          cls: "btn-x"
          callback: (e)->
            dialog.remove()
        }]
    return false

  tower.initPermission($popover)


todoClick = (e, todo, $todo) ->
  $popover = $($('#tpl-todo-click-popover').html())

  $popover.find('.content').text(todo.content)
    .attr('href', "/projects/#{todo.origin.project_guid}/todos/#{todo.id}")

  $popover.find('.more-info')
    .attr('href', "/projects/#{todo.origin.project_guid}/todos/#{todo.id}")

  if todo.origin.assignee_nickname
    $popover.find('.cal-todo-item-avatar').replaceWith("""
      <img class="avatar" src="#{todo.origin.assignee_avatar}">
    """)
    $popover.find('.cal-todo-item-assignee .cal-todo-item-text').text(todo.origin.assignee_nickname)
  else
    $popover.find('.cal-todo-item-assignee').remove()

  date = todo.end.format('M月D日')
  date = "#{todo.start.format('M月D日')} - #{date}" if todo.start
  $popover.find('.cal-todo-item-date .cal-todo-item-text').text(date)

  $popover.find('.cal-todo-item-priority')
    .attr('data-priority', todo.origin.priority)
    .find('.cal-todo-item-text')
    .text(todo.origin.priority_text)

  $popover.find('.cal-todo-item-project .cal-todo-item-text')
    .text(todo.origin.project_name)

  $pointTo = $todo.find('.content .text')
  $pointTo = $todo.find('.content') unless $pointTo.length
  if $pointTo.outerWidth() > $pointTo.parent().width()
    $pointTo = $pointTo.parent()

  popover = simple.popover
    pointTo: $pointTo
    content: $popover
    cls: 'calendar-event-popover'


todoComplete = (e, todo) ->
  calendar = $('#calendar').data('calendar')
  action = if todo.completed then 'complete' else 'reopen'
  $.ajax
    url: "/projects/#{todo.origin.project_guid}/todos/#{todo.id}/#{action}/"
    dataType: 'json'
    type: 'post'
    success: (result) ->
      if todo.completed
        calendar.removeTodo todo.id


getLocalStorageKey = () ->
  'calEventFilter_' + location.pathname.match(/\/([a-z0-9]{32})\//)[1]

renderTodoMember = (todo, $content) ->
  return unless todo.origin.assignee_avatar && todo.origin.assignee_nickname
  $content.prepend """
    <span class="members">
      <img class="avatar" src="#{todo.origin.assignee_avatar}" alt="#{todo.origin.assignee_nickname}" title="#{todo.origin.assignee_nickname}">
      <span class="nickname">[#{todo.origin.assignee_nickname}]</span>
    </span>
  """

renderEventMembers = (event, $content, allDay) ->
  return if event.origin.create
  $members = $('<span class="members"></span>')

  if event.origin.is_show_creator
    $members.append """
      <img class="avatar" src="#{event.origin.creator.avatar}" alt="#{event.origin.creator.nickname}" title="#{event.origin.creator.nickname}">
      <span class="nickname">[#{event.origin.creator.nickname}]</span>
    """
  else if event.origin.participants.length > 0 && !allDay
    limit = 4
    for participant, index in event.origin.participants
      break if index == limit
      $members.append """<img class="avatar" src="#{participant.avatar}" alt="#{participant.nickname}" title="#{participant.nickname}">"""

    if (more = event.origin.participants.length - limit) > 0
      more = if more > 9 then '•••' else "+#{more}"
      $members.append """<span class="avatar avatar-placeholder">#{more}</span>"""

  if $members.find('.avatar').length == 1
    $members.prependTo($content)
  else if $members.find('.avatar').length > 1
    $members.appendTo($content).addClass 'multi-members'

toggleCals = ->
  $cals = $('.project-cals')
  folded = (simple.util.storage.get('foldProjectCals') == 'true')
  $cals.toggleClass('folded', folded)

  $('.link-fold-cals').click ->
    folded = !$cals.hasClass('folded')
    $cals.toggleClass('folded', folded)
    simple.util.storage.set('foldProjectCals', folded)
